import { PropsWithChildren } from "react";
import classes from "./SideBar.module.css";

const SideBar: React.FC<PropsWithChildren> = (props) => {
  return <div className={classes["sidebar-window"]}>{props.children}</div>;
};

export default SideBar;
